export function toggleBib(key: string): void {
  const el = document.getElementById(key) as HTMLElement | null;
  if (!el) return;
  el.style.display = el.style.display === "block" ? "none" : "block";
}

export function copyBib(key: string): void {
  const el = document.getElementById(key);
  if (!el) return;
  const text = el.textContent || el.innerText;
  navigator.clipboard.writeText(text.replace(/^\s*BibTeX:\s*/, ""));
}

export function filterPubs(input: HTMLInputElement): void {
  const query = input.value.toLowerCase().trim();

  document.querySelectorAll<HTMLElement>(".bib-entry").forEach((item) => {
    const text = item.textContent?.toLowerCase() ?? "";
    const li = item.closest<HTMLElement>("li");
    const visible = !query || text.includes(query);
    if (li) li.style.display = visible ? "" : "none";
    item.style.display = visible ? "" : "none";
  });

  document.querySelectorAll<HTMLDetailsElement>(".pub-subsection").forEach((sub) => {
    const entries = sub.querySelectorAll<HTMLElement>(".bib-entry");
    let visibleCount = 0;
    entries.forEach((e) => {
      if (e.style.display !== "none") visibleCount++;
    });
    const countSpan = sub.querySelector<HTMLElement>(".pub-count");
    if (countSpan) countSpan.textContent = `(${visibleCount})`;
    if (visibleCount === 0) {
      sub.removeAttribute("open");
      sub.style.display = "none";
    } else {
      sub.style.display = "";
      if (query) sub.setAttribute("open", "");
    }
  });

  document.querySelectorAll<HTMLDetailsElement>(".pub-section").forEach((sec) => {
    const subs = sec.querySelectorAll<HTMLElement>(".pub-subsection");
    let anyVisible = false;
    subs.forEach((s) => {
      if (s.style.display !== "none") anyVisible = true;
    });
    if (!anyVisible && query) {
      sec.removeAttribute("open");
      sec.style.display = "none";
    } else {
      sec.style.display = "";
    }
  });
}

interface AuthorLink {
  name: string;
  url: string;
}

type EntryAuthors = Record<string, AuthorLink[]>;

export function initAuthorLinks(): void {
  const bibEntries = document.querySelectorAll<HTMLElement>(".bib-entry");
  if (bibEntries.length === 0) return;

  fetch("/assets/data/people-links.json")
    .then((r) => r.json() as Promise<EntryAuthors>)
    .then((entryAuthors) => {
      bibEntries.forEach((entry) => {
        const key = entry.id.replace("cite-", "");
        const authors = entryAuthors[key];
        if (!authors || authors.length === 0) return;

        const linksEl = entry.querySelector(".bib-links");
        if (!linksEl) return;

        const teamSpan = document.createElement("span");
        teamSpan.className = "bib-team";
        teamSpan.style.cssText = "display:inline; margin-left:0.5rem; font-size:0.8rem;";
        teamSpan.appendChild(document.createTextNode(" "));

        authors.forEach((author, i) => {
          if (i > 0) teamSpan.appendChild(document.createTextNode(", "));
          const a = document.createElement("a");
          a.href = author.url;
          a.textContent = author.name;
          a.title = `View profile: ${author.name}`;
          a.style.cssText = "font-size:0.8rem;";
          teamSpan.appendChild(a);
        });

        linksEl.appendChild(teamSpan);
      });
    })
    .catch(() => {});
}

export function initSearchFromUrl(): void {
  const params = new URLSearchParams(window.location.search);
  const q = params.get("q");
  if (q) {
    const searchInput = document.querySelector<HTMLInputElement>('.pub-search input[type="search"]');
    if (searchInput) {
      searchInput.value = q;
      filterPubs(searchInput);
    }
  }
}
